import React from 'react'

import './About_card.css'
import { Air_button } from '../Button/Air_button'


import plane from '../../assets/images/plane.svg'
import { Translate } from '../Translate/Translate'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { ChevronRight } from '@mui/icons-material'

const About_card = (props) => {
    const { t } = useTranslation()

    return (
        <>
            <div className=" wow fadeInUp" data-wow-delay="100ms">
                <div className="services-one__single">
                    <div className="services-one__img">
                        <img src={props.image} alt="" className='w-full h-[300px] object-cover' />
                    </div>
                    <div className="z-[2] relative block h-[130px] bg-white -mt-9 mr-9 py-7 px-7 rounded-md" style={{boxShadow: "0px 4px 10px 0px #0000000D"}}>
                        <div className="services-one__title-box">
                            <h4 className="services-one__title"><Link to={`${props.navigate__}`} style={{ textDecoration: 'none' }}>{t(props.title)}</Link>
                            </h4>
                        </div>
                        <p className="services-one__text">{t(props.content)}</p>
                        <div className="services-one__arrow">
                            <Link to={`${props.navigate__}`} style={{ textDecoration: 'none' }}><ChevronRight /></Link>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default About_card